import { DocumentTypeHandler } from "@/dbot/common/commonDomain";
import {
  applyForm,
  NoticeOfBoardMeeting,
  NoticeOfBoardMeetingForm,
} from "./noticeBoardMeetingDomain";
import { DocumentType } from "@/common/documents";

export const noticeBoardMeetingHandler: DocumentTypeHandler<
  DocumentType.notice_board_meeting,
  NoticeOfBoardMeeting,
  NoticeOfBoardMeetingForm
> = {
  type: DocumentType.notice_board_meeting,
  initNewForm: (dispatch, context) => new NoticeOfBoardMeetingForm(context, dispatch),
  initForm: (form) => form.init(),
  handleEvent: (form, event) => form.handleEvent(event),
  applyForm: (form) => applyForm(form),
};
